import React, { useContext } from "react";
import { useTranslation } from 'react-i18next';

import { ReactComponent as SaveCollection } from "static/icons/save-collection.svg";

import UniversalButton from "components/uiComponents/UniversalButton";
import SaveCollectionModal from "components/modals/SaveCollectionModal";
import { ModalContext } from "components/ModalContext";

const SaveAsCollection = ({ tableInfo, unstyled }) => {
  const { t } = useTranslation();
  const { handleModal } = useContext(ModalContext);

  const openModal = () => {
    handleModal(
      <SaveCollectionModal
        closeCollectionModal={closeModal}
        tableInfo={tableInfo}
        selected
      />,
      false,
      true
    );
  };

  const closeModal = () => handleModal(null, true);

  return (
    <>
      <UniversalButton
        style={{ height: "32px" }}
        label={t('save_selection_set')}
        size="md"
        labelColor="blue"
        labelHoverColor="blue"
        backgroundColor="blue"
        backgroundHoverColor="$blue"
        leftIcon={<SaveCollection />}
        onClick={openModal}
        isRounded="sm"
        unstyled={unstyled}
      />
    </>
  );
};

export default SaveAsCollection;
